module.exports = __webpack_public_path__ + "static/media/team4.cf22bc7f.jpg";